import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/icon_filter.svg'


const _hoisted_1 = { class: "q-px-xl" }
const _hoisted_2 = {
  id: "div-pesquisa-campanha",
  class: "row q-pb-lg"
}
const _hoisted_3 = { class: "row fit no-wrap justify-between items-end" }
const _hoisted_4 = { class: "col-grow" }
const _hoisted_5 = { class: "row justify-center q-mt-md" }
const _hoisted_6 = { style: {"width":"100%"} }
const _hoisted_7 = { class: "midia-app-title-header-table-lg" }
const _hoisted_8 = { class: "midia-app-label-lg" }
const _hoisted_9 = { class: "row full-width items-center justify-end q-pa-sm q-gutter-sm" }
const _hoisted_10 = { class: "midia-app-label-sm" }
const _hoisted_11 = { class: "row justify-end q-mt-sm" }
const _hoisted_12 = { class: "text-right" }

import { ref, computed, onMounted } from 'vue'
import useQuasar from 'quasar/src/composables/use-quasar/use-quasar.js';
import { usePagesUtilStore } from '@/stores/pagesUtilStore'
import { useInstitutionalStore } from '@/stores/institutionalStore'
import { quasarCustomQTableColumns } from '@/types/quasarCustomQTableColumn'
import ModalFilterConsulta from '@/views/layout/modalsConsulta/ModalFilterConsulta.vue'
import { useRedeSubredeStore } from '@/stores/redeSubredeStore'
import { CONST_INSTITUTIONAL_STATUS } from '@/static/constantsInstitutional'


export default /*@__PURE__*/_defineComponent({
  __name: 'PageRegistrySearch',
  setup(__props) {

const redeSubredeStore = useRedeSubredeStore()
const $q = useQuasar()
const pagesUtilStore = usePagesUtilStore()
const institutionalStore = useInstitutionalStore()

/* =========================
 * FILTRO
 * ========================= */
const filterTerms = ref('')

/* =========================
 * PAGINAÇÃO
 * ========================= */
const pagination = ref({
  page: 1,
  rowsPerPage: 10,
  sortBy: 'id',
  descending: false
})

const formatTelas = (telas: string) => {
  if (!telas) return '-'
  const map: Record<string, string> = {
    'INICIAL': 'Iniciais',
    'AGUARDE': 'Aguarde',
    'ABERTURA': 'Abertura'
  }
  return telas.split(',').map(t => map[t.trim()] ?? t).join(', ')
}

const formatDateBr = (date?: string | null) => {
  if (!date) return '-'
  const [year, month, day] = date.split('-')
  return `${day}/${month}/${year}`
}

/* =====================
 * SEARCH
 * ===================== */
let searchTimeout: ReturnType<typeof setTimeout> | null = null

const onSearchInput = async (value: string | number | null) => {
  if (searchTimeout) clearTimeout(searchTimeout)

  searchTimeout = setTimeout(async () => {
    const term = value ? String(value).trim() : ''

    if (term) {
      institutionalStore.institutionalFilter = { nome: term }
    } else {
      institutionalStore.resetInstitutionalFilter()
    }
    await institutionalStore.fetchInstitutionalScreens()
  }, 400)
}


/* =========================
 * MAPPER BACK → TABLE
 * ========================= */
const rows = computed(() =>
  institutionalStore.institutionalScreens.map(item => {
    const rede = item.redes?.[0]

    // ✅ AQUI - antes do return
    const subredesNomes = item.redes?.map(r => {
      const info = redeSubredeStore.subredes.find(
        s => s.codSubredeAutoAtndto === r.codSubrede
      )
      return info?.nomSubredeAutoAtndto ?? r.codSubrede
    }).join(', ') ?? '-'

    return {
      id: item.id,
      register: item.nome,
      networkCode: rede?.codRede ?? '-',
      network: rede?.codRede ? 'Banco24Horas' : '-',
      subnetCode: item.redes?.map(r => r.codSubrede).join(', ') ?? '-',
      subnet: subredesNomes,  // ✅ todos os nomes
      pc: item.pcsIds?.length ? item.pcsIds.join(', ') : '-',
      startDate: formatDateBr(item.dtIniVigencia),
      endDate: formatDateBr(item.dtFimVigencia),
      screen: formatTelas(item.telasCadastradas),
      profile: item.perfil ?? '-',
      granularity: item.pcsIds?.length
                    ? 'Por PC'
                    : item.redes?.length === redeSubredeStore.subredes.length
                      ? 'Por Rede'
                      : item.redes?.length
                        ? 'Por Subrede'
                        : '-',
      status: item.status,
    }
  })
)

/* =========================
 * FILTRO LOCAL
 * ========================= */
const filteredRows = computed(() => {
  const term = filterTerms.value.toLowerCase()

  return rows.value.filter(row => {
    // ✅ filtro da barra de busca
    const matchSearch = !term || Object.values(row).some(val =>
      String(val ?? '').toLowerCase().includes(term)
    )

    // ✅ filtro de granularidade do modal
    const matchGranularity = !institutionalStore.institutionalFilter.granularidade
      || row.granularity === institutionalStore.institutionalFilter.granularidade

    return matchSearch && matchGranularity
  })
})

/* =========================
 * COLUNAS
 * ========================= */
const qTableConsultaColumns: quasarCustomQTableColumns[] = [
  { name: 'id', label: 'ID', field: 'id', align: 'center' },
  { name: 'register', label: 'Cadastro', field: 'register', align: 'left' },
  { name: 'networkCode', label: 'Cód. Rede', field: 'networkCode', align: 'left' },
  { name: 'network', label: 'Rede', field: 'network', align: 'left' },
  { name: 'subnetCode', label: 'Cód. Subrede', field: 'subnetCode', align: 'left' },
  { name: 'subnet', label: 'Subrede', field: 'subnet', align: 'left' },
  { name: 'pc', label: 'PC', field: 'pc', align: 'left' },
  { name: 'startDate', label: 'Início', field: 'startDate', align: 'left' },
  { name: 'endDate', label: 'Fim', field: 'endDate', align: 'left' },
  { name: 'screen', label: 'Tela', field: 'screen', align: 'left' },
  { name: 'profile', label: 'Perfil', field: 'profile', align: 'left' },
  { name: 'granularity', label: 'Granularidade', field: 'granularity', align: 'left' }
]

const getStatusLabel = (statusId: number | string) => {
  const status = Object.values(CONST_INSTITUTIONAL_STATUS)
    .find(s => s.id === statusId)

  return status?.description ?? statusId
}

/* =========================
 * EXPORT CSV
 * ========================= */
const exportToCsv = () => {
  const headers = [
    'ID',
    'Cadastro',
    'Cód. Rede',
    'Rede',
    'Cód. Subrede',
    'Subrede',
    'PC',
    'Início',
    'Fim',
    'Tela',
    'Perfil',
    'Granularidade',
    'Status'
  ].join(';')

  const body = filteredRows.value.map(row => [
    `"${row.id ?? ''}"`,
    `"${row.register ?? ''}"`,
    `"${row.networkCode ?? ''}"`,
    `"${row.network ?? ''}"`,
    `"${row.subnetCode ?? ''}"`,
    `"${row.subnet ?? ''}"`,
    `"${row.pc ?? ''}"`,
    `"${row.startDate ?? ''}"`,
    `"${row.endDate ?? ''}"`,
    `"${row.screen ?? ''}"`,
    `"${row.profile ?? ''}"`,
    `"${row.granularity ?? ''}"`,
    `"${getStatusLabel(row.status)}"`
  ].join(';'))

  const csv = [headers, ...body].join('\n')

  const blob = new Blob(['\uFEFF' + csv], {
    type: 'text/csv;charset=utf-8;'
  })

  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = url
  link.download = 'cadastros_telas_institucionais.csv'
  link.click()

  URL.revokeObjectURL(url)
}


/* =========================
 * FILTRO MODAL
 * ========================= */
const onFilterBtnClick = () => {
  pagesUtilStore.showModalFilterInstitutional = true
}

/* =========================
 * INIT
 * ========================= */
onMounted(async () => {
  try {
    pagesUtilStore.showLoading = true
    await redeSubredeStore.carregarSubredes()
    await institutionalStore.fetchInstitutionalScreens()
  } finally {
    pagesUtilStore.showLoading = false
  }
})

return (_ctx: any,_cache: any) => {
  const _component_c_q_separator = _resolveComponent("c-q-separator")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_th = _resolveComponent("q-th")!
  const _component_q_tr = _resolveComponent("q-tr")!
  const _component_q_td = _resolveComponent("q-td")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_c_q_separator, { class: "q-pb-lg" }),
      _createElementVNode("div", _hoisted_2, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "q-pb-xs" }, [
          _createElementVNode("span", { class: "midia-app-label-lg" }, "Pesquise um Cadastro")
        ], -1)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_q_input, {
              id: "searchbar",
              modelValue: filterTerms.value,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((filterTerms).value = $event)),
                onSearchInput
              ],
              color: "globalAppPrimaryColor",
              "bg-color": "globalAppDefaultBackgroundColor",
              outlined: "",
              dense: "",
              placeholder: "Busque um Cadastro"
            }, {
              prepend: _withCtx(() => [
                _createVNode(_component_q_icon, {
                  name: "search",
                  class: "q-pa-sm",
                  style: {"background":"var(--globalAppSecondaryColor4)","padding":"6px","position":"relative","left":"-11px","border-right":"1px solid var(--globalAppSecondaryColor2)"}
                })
              ]),
              append: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  id: "btn-show-filterbox",
                  unelevated: "",
                  outlined: "",
                  "no-caps": "",
                  onClick: onFilterBtnClick
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_icon, { size: "16px" }, {
                      default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                        _createElementVNode("img", {
                          class: "svg-icon",
                          src: _imports_0
                        }, null, -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "midia-app-label-lg q-pl-sm" }, "Filtrar", -1))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])
      ]),
      _cache[13] || (_cache[13] = _createElementVNode("span", { class: "midia-app-label-sm" }, "Cadastros encontrados", -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_q_table, {
            class: "midia-app-table",
            "row-key": "id",
            flat: "",
            separator: "horizontal",
            rows: filteredRows.value,
            columns: qTableConsultaColumns,
            pagination: pagination.value,
            "onUpdate:pagination": _cache[7] || (_cache[7] = ($event: any) => ((pagination).value = $event)),
            "rows-per-page-options": [5, 10, 25, 50, 100],
            "no-data-label": "Nenhum registro encontrado!",
            "rows-per-page-label": "Linhas por página:",
            dense: _unref($q).screen.lt.md
          }, {
            header: _withCtx((props) => [
              _createVNode(_component_q_tr, { props: props }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.cols, (col) => {
                    return (_openBlock(), _createBlock(_component_q_th, {
                      key: col.name,
                      props: props,
                      style: {"background":"var(--globalAppSecondaryColor4)","border":"0"}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_7, _toDisplayString(col.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["props"]))
                  }), 128))
                ]),
                _: 2
              }, 1032, ["props"])
            ]),
            body: _withCtx((props) => [
              _createVNode(_component_q_tr, {
                props: props,
                class: "table-body-rows"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(qTableConsultaColumns, (col) => {
                    return _createVNode(_component_q_td, {
                      key: col.name,
                      props: props
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", _hoisted_8, _toDisplayString(props.row[col.field]), 1)
                      ]),
                      _: 2
                    }, 1032, ["props"])
                  }), 64))
                ]),
                _: 2
              }, 1032, ["props"])
            ]),
            bottom: _withCtx(() => [
              _createElementVNode("div", _hoisted_9, [
                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "midia-app-label-sm" }, "Linhas por página:", -1)),
                _createVNode(_component_q_select, {
                  modelValue: pagination.value.rowsPerPage,
                  "onUpdate:modelValue": [
                    _cache[1] || (_cache[1] = ($event: any) => ((pagination.value.rowsPerPage) = $event)),
                    _cache[2] || (_cache[2] = ($event: any) => (pagination.value.page = 1))
                  ],
                  options: [5, 10, 25, 50, 100],
                  dense: "",
                  outlined: "",
                  style: {"width":"70px"}
                }, null, 8, ["modelValue"]),
                _createElementVNode("span", _hoisted_10, _toDisplayString((pagination.value.page - 1) * pagination.value.rowsPerPage + 1) + "-" + _toDisplayString(Math.min(pagination.value.page * pagination.value.rowsPerPage, filteredRows.value.length)) + " de " + _toDisplayString(filteredRows.value.length), 1),
                _createVNode(_component_q_btn, {
                  flat: "",
                  dense: "",
                  round: "",
                  icon: "first_page",
                  disable: pagination.value.page === 1,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (pagination.value.page = 1))
                }, null, 8, ["disable"]),
                _createVNode(_component_q_btn, {
                  flat: "",
                  dense: "",
                  round: "",
                  icon: "chevron_left",
                  disable: pagination.value.page === 1,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (pagination.value.page--))
                }, null, 8, ["disable"]),
                _createVNode(_component_q_btn, {
                  flat: "",
                  dense: "",
                  round: "",
                  icon: "chevron_right",
                  disable: pagination.value.page * pagination.value.rowsPerPage >= filteredRows.value.length,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (pagination.value.page++))
                }, null, 8, ["disable"]),
                _createVNode(_component_q_btn, {
                  flat: "",
                  dense: "",
                  round: "",
                  icon: "last_page",
                  disable: pagination.value.page * pagination.value.rowsPerPage >= filteredRows.value.length,
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (pagination.value.page = Math.ceil(filteredRows.value.length / pagination.value.rowsPerPage)))
                }, null, 8, ["disable"])
              ])
            ]),
            _: 1
          }, 8, ["rows", "pagination", "dense"]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[12] || (_cache[12] = _createElementVNode("span", { class: "midia-app-label-sm" }, "Exportar Lista", -1)),
              _createElementVNode("div", null, [
                _createVNode(_component_q_btn, {
                  size: "sm",
                  outline: "",
                  color: "primary",
                  label: "Download",
                  onClick: exportToCsv
                })
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_c_q_separator, { class: "q-my-md" })
    ]),
    _createVNode(ModalFilterConsulta)
  ], 64))
}
}

})